<template>
<div class="parent">
  <div class="half-circle-spinner">
    <div class="circle circle-1"></div>
    <div class="circle circle-2"></div>
  </div>
  <p class="text">Loading, please wait...</p>
</div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ArnergyLoader"
};
</script>

<style lang="scss" scoped>
.parent {
  position: fixed;
  z-index: 10000;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba($color: white, $alpha: .9);
}

.text{
  color: #333;
  margin-top: 20px;
  font-weight: bold;
}

.half-circle-spinner,
.half-circle-spinner * {
  box-sizing: border-box;
}

.half-circle-spinner {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  position: relative;
}

.half-circle-spinner .circle {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: calc(50px / 10) solid transparent;
}

.half-circle-spinner .circle.circle-1 {
  border-top-color: #ffb946;
  animation: half-circle-spinner-animation 1s infinite;
}

.half-circle-spinner .circle.circle-2 {
  border-bottom-color: #ffb946;
  animation: half-circle-spinner-animation 1s infinite alternate;
}

@keyframes half-circle-spinner-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergyLoader.vue